import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const CookieBanner = () => {
  const { t } = useLanguage();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("xs-cookie-consent")) setShow(true);
  }, []);

  const decide = (accepted) => {
    localStorage.setItem("xs-cookie-consent", accepted ? "accepted" : "rejected");
    try {
      if (window.posthog) {
        if (accepted) window.posthog.opt_in_capturing();
        else window.posthog.opt_out_capturing();
      }
    } catch {
      // analytics opzionale
    }
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          className="fixed z-[66] glass-panel rounded-2xl p-5 max-sm:top-20 max-sm:left-4 max-sm:right-4 sm:bottom-6 sm:left-6 sm:max-w-sm sm:p-6"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          transition={{ duration: 0.35 }}
        >
          <div className="flex items-center gap-2 mb-3 text-neon-cyan">
            <Cookie size={18} />
            <p className="text-sm font-semibold text-white">{t.cookies.title}</p>
          </div>
          <p className="text-xs text-white/60 leading-relaxed mb-4">
            {t.cookies.text}{" "}
            <a href="/cookie-policy" className="text-neon-cyan underline">Cookie Policy</a> ·{" "}
            <a href="/privacy" className="text-neon-cyan underline">Privacy Policy</a>
          </p>
          <div className="flex gap-3">
            <button
              onClick={() => decide(true)}
              data-testid="cookie-accept-button"
              className="flex-1 btn-cyber bg-gradient-to-r from-neon-cyan to-neon-violet px-4 py-2.5 text-xs font-semibold text-void hover:opacity-90 transition-opacity"
            >
              {t.cookies.accept}
            </button>
            <button
              onClick={() => decide(false)}
              data-testid="cookie-reject-button"
              className="flex-1 btn-cyber border border-white/20 px-4 py-2.5 text-xs text-white/70 hover:text-white hover:border-neon-cyan/50 transition-colors"
            >
              {t.cookies.reject}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
